<script setup lang="ts">
import {Button} from "@/core/components/ui/button";
import {openDMP} from "@/core/helpers/dmp";
</script>

<template>
  <!-- Same recipe as the MSSanté button (outline pill, h-6 logo), so the two
       stay pixel-identical wherever they sit side by side. -->
  <Button variant="outline" class="text-primary rounded-full" @click="openDMP">
    <img src="@/assets/images/dmp.jpg" class="h-6 rounded-full" alt="DMP">
    Accéder au DMP
  </Button>
</template>
